import service from './index'

const createLuckyRunner = service.resource('lucky-runners/create')
const resourceLuckyLiveRunners = service.resource('lucky-runners/search/{ = startDate}{ = endDate}{ = page}{ = size}{ = sort}')
const resourceLuckyLiveRunnersByRaceId = service.resource('lucky-runners/search/{ = raceId}')
const updateLuckyRunner = service.resource('lucky-runners/update')
const removeLuckyRunner = service.resource('lucky-runners/delete/{id}')

export default {
  
  create(data){
    return createLuckyRunner.save(data)
  },

  getLuckyLiveRunners(startDate,endDate,page,size) {
    if(startDate!='' && endDate!='' && startDate!=undefined && endDate!=undefined){
      return resourceLuckyLiveRunners.get({startDate: startDate,endDate:endDate,page:page,size:size,sort:"raceDateTime,desc"})
    }else{
      return resourceLuckyLiveRunners.get({page:page,size:size,sort:"raceDateTime,desc"})
    }
  },

  getLuckyLiveRunnersByRaceId(raceId) {
    return resourceLuckyLiveRunnersByRaceId.get({raceId: raceId})
  },

  updateLuckyLiveRunnerData(data){
    return updateLuckyRunner.update(data)
  },

  deleteLuckyLiveRunner(id){
    return removeLuckyRunner.delete({id:id})
  }  
  
}




// WEBPACK FOOTER //
// ./src/services/luckyLiveRunner.js